import axios from 'axios';
import {SW_BE_HOST} from '../data/constants'

const axiosBEInstance = axios.create({
    baseURL: SW_BE_HOST,
    withCredentials:true,
    timeout:30000,
});


export default axiosBEInstance;